module.exports = [
  require('./dream_of_the_blue_veil'),
]
